import e from "react";
import p from "./index37.js";
import "./index29.js";
import "./index30.js";
import "./index31.js";
import "./index32.js";
import "./index33.js";
import "./index34.js";
import "./index35.js";
const i = p((t) => {
  let {
    inputRef: r,
    ...o
  } = t;
  return e.createElement("input", {
    ...o,
    ref: r
  });
}), m = (t, r) => e.createElement(i, {
  ...t,
  ref: r
}), k = e.forwardRef(m);
export {
  k as default
};
